import React from 'react'
import "../Styles/Values.css"
import Color from '../Components/Colors/Color';

const Values = () => {
    return(
        <div className='values-container' style={{color: Color.secondaryText}}>

            <h1 className='values-header'style={{color: Color.secondaryText}}>
                Values
            </h1>


            <div className='values-section-content-container'>

            <div className='values-image-container-medium'>
                    <img src='/Images/values-image-1.png' alt='values-image' className='values-image-medium' />
            </div>

            <div className='values-text-image-container row'>
                <div className='values-text-container col-lg-6'>
                
                    <ul className='values-content-list'>
                        <div className='values-hl-container-list'></div>
                        <li className='values-content-item'>
                            <h4 className='values-content-header'>Quality Obsessed</h4>
                            <p className='values-content-text'>
                                Ensure top standards for consumables, precise repairs by skilled technicians, 
                                customer satisfaction, sustainable practices, and continuous improvement.
                            </p>
                        </li>
                        <li className='values-content-item'>
                            <h4 className='values-content-header'>Efficient Dependability</h4>
                            <p className='values-content-text'>
                                Fast turnaround, on-time delivery, and unwavering reliability in every project.
                            </p>
                        </li>
                        <li className='values-content-item'>
                            <h4 className='values-content-header'>Expert Guidance</h4>
                            <p className='values-content-text'>
                                Knowledgeable assistance, reliable repairs, and expert support to meet your needs.
                            </p>
                        </li>
                        <div className='values-hl-container-list'></div>
                    </ul>
                    
                </div>
                <div className='values-image-container col-lg-6 col-md-12'>
                    <div className='values-hl-container'></div>
                    <img src='/Images/values-image-1.png' alt='values-image' className='values-image' />
                </div>
            </div>
            </div>
        </div>
    )
}

export default Values;